import React from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'
import useTrans from '../../../../../hooks/useTrans'
import usePrivacy from '../../../../../hooks/usePrivacy'
import { useSelector } from 'react-redux'
import { getRequiredFields } from '../../../../../utils/servicegift'

const Autorizzazioni = ({
  step,
  setStep,
  props,
  getUrlCondizioniGenerali,
  variant = 'registrazione',
}) => {
  const t = useTrans()
  const isCheckout = variant === 'checkout'
  const { service_gift } = useSelector((state) => state?.servicegift)
  const { getUrlInformativaFromStore } = usePrivacy()

  const requiredFields = getRequiredFields(service_gift, props.values.utente.tipologia, variant)

  return (
    <div className="step-registrazione">
      {isCheckout && (
        <p className="personalizzazione__item__placeholder">{t('Autorizzazioni e consensi')}</p>
      )}
      <div className="step-registrazione__fieldsets step-registrazione__fieldsets--full-rows">
        <FormField>
          <p className="registrazione__template__disclaimer">
            {t('Cliccando sul tasto {0} dichiaro di aver letto e compreso ', [
              isCheckout ? `"${t('Conferma dati')}"` : `"${t('Conferma Registrazione')}"`,
            ])}{' '}
            <a
              style={{ textDecoration: 'underline', fontWeight: 'bold' }}
              href={getUrlInformativaFromStore()}
              target="_blank"
            >
              {' '}
              {t("l'Informativa Privacy")}{' '}
            </a>
            {/* Condizioni generali solo per SG http://project.webranking.it/#/tasks/27490340 */}
            {t('e le')}{' '}
            <a
              style={{ textDecoration: 'underline', fontWeight: 'bold' }}
              href={getUrlCondizioniGenerali()}
              target="_blank"
            >
              {t('Condizioni Generali del Servizio di Fornitura')}
            </a>
          </p>
          {/* <FormCheckbox
            label="Dichiaro di aver preso visione dell'informativa sulla Privacy in calce alla pagina*"
            checked={props.values.autorizzazioni?.privacy}
            onChange={() =>
              props.setFieldValue('autorizzazioni.privacy', !props.values.autorizzazioni?.privacy)
            }
            onBlur={props.handleBlur('autorizzazioni.privacy')}
          /> */}
        </FormField>
        <FormField>
          <FormCheckbox
            label={
              t(
                "Acconsento all'invio di comunicazioni di marketing contenenti informazioni, aggiornamenti ed offerte commerciali proprie e/o di terzi."
              ) + (requiredFields.includes('utente.autorizzazioni_consensi') ? ' *' : '')
            }
            onChange={() =>
              props.setFieldValue(
                'autorizzazioni.privacy_commerciale',
                !props.values.autorizzazioni?.privacy_commerciale
              )
            }
            checked={props.values.autorizzazioni?.privacy_commerciale}
            onBlur={props.handleBlur('autorizzazioni.privacy_commerciale')}
            id={"autorizzazioni-privacy-commerciale"}
          />
        </FormField>
      </div>

      {!isCheckout && (
        <>
          <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>
          <Button
            disabled={props.errors.autorizzazioni || !props.dirty}
            label="Conferma consensi"
            variant="primary"
            size="medium"
            onClick={() => setStep(step + 1)}
          />
        </>
      )}
    </div>
  )
}

export default Autorizzazioni
